import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import StatsSection from './components/StatsSection';
import CategorySection from './components/CategorySection';
import NewsSection from './components/NewsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function HomePage() {
  const { t } = useTranslation();

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: t('schema.org_name'),
        url: 'https://www.kaiyun.com',
        description: t('schema.description'),
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '400-XXX-XXXX',
          contactType: 'customer service',
          availableLanguage: ['Chinese'],
          hoursAvailable: {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
            opens: '00:00',
            closes: '23:59',
          },
        },
      },
      {
        '@type': 'WebSite',
        name: t('schema.org_name'),
        url: 'https://www.kaiyun.com',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://www.kaiyun.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: t('schema.org_name') + ' - ' + t('hero.title'),
        description: t('hero.subtitle'),
        url: 'https://www.kaiyun.com',
        isPartOf: { '@type': 'WebSite', name: t('schema.org_name'), url: 'https://www.kaiyun.com' },
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          { '@type': 'Question', name: 'kaiyun com 是正版授权平台吗？', acceptedAnswer: { '@type': 'Answer', text: '是的，kaiyun com 是经过官方认证的正版授权平台。我们持有完整的运营资质，严格遵守相关法律法规。' } },
          { '@type': 'Question', name: '如何注册 kaiyun com 账号？', acceptedAnswer: { '@type': 'Answer', text: '您只需点击平台首页的"注册"按钮，按照提示填写基本信息，设置登录密码，完成验证后即可成功注册。' } },
          { '@type': 'Question', name: '平台的安全性如何保障？', acceptedAnswer: { '@type': 'Answer', text: 'kaiyun com 采用银行级安全防护体系，包括加密传输协议、多重身份验证机制、实时风控监控系统以及定期安全审计。' } },
          { '@type': 'Question', name: '遇到问题如何联系客服？', acceptedAnswer: { '@type': 'Answer', text: '我们提供7×24小时全天候客服支持，您可以通过在线客服、官方邮箱或电话热线联系我们。' } },
        ],
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeatureSection />
        <StatsSection />
        <CategorySection />
        <NewsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}